import $ from 'jquery';
import matchHeight from 'jquery-match-height';

const setAccordion = () => {
  const $trigger = $('.is-accordion,.js-accordion');
  if ($trigger.length < 1) { return; }
  $trigger.off().on('click', function(event){
    event.preventDefault();
    $(this).toggleClass('active').
    next().stop(true,true).slideToggle();
  });
};

const setTextTile = () => {
  const $el = $('.textCard_link');
  if ( $el.length < 1 ) { return; }
  $el.matchHeight();
};

module.exports = {
  setAccordion   : setAccordion,
  setTextTile    : setTextTile
};



// WEBPACK FOOTER //
// ./src/js/modules/common.js